import React, { useEffect } from 'react';
import firebase from 'firebase/app';
import { firestore } from '../../utils/firebase';
import "firebase/firestore";
const db = firebase.firestore();


const WriteReview = () => {

    document.title = "Veta - Write review";

    const submitSuccess = async () => {
        let submitForm = await document.getElementById("ReviewForm");
        let submitLoading = await document.getElementById("submit-loading");
        let reviewSent = await document.getElementById("review-sent");
        submitForm.style.display = "none";
        submitLoading.style.display = "none";
        reviewSent.style.display = "block";
    }

    const loading = async () => {
        let submitForm = await document.getElementById("ReviewForm");
        let submitLoading = await document.getElementById("submit-loading");
        submitForm.style.display = "none";
        submitLoading.style.display = "flex";
    }
        
    const submitReview = async (e) => {
        e.preventDefault();
        let user_full_name = await document.getElementById("Full-Name").value;
        let user_role = await document.getElementById("Role").value;
        let user_review_content = await document.getElementById("Review-Content").value;

        loading();
    
        try {
            db.collection("reviews").add({
                Full_Name: user_full_name,
                Role: user_role,
                Content: user_review_content
        }).then(() => {
            submitSuccess();
        })
        } catch(error)  {
            console.error("Error adding document: ", error);
        };
    }

    const check = async () => {
        let nameInput = await document.getElementById("Full-Name").value;
        let roleInput = await document.getElementById("Role").value;
        let contentInput = await document.getElementById("Review-Content").value;
        let submitButton = await document.getElementById("submit-btn");

        if (nameInput && roleInput && contentInput.length > 0) {
            submitButton.style.opacity = "1";
            submitButton.style.cursor = "pointer";
        } else {
            submitButton.style.opacity = "0.2";
            submitButton.style.cursor = "not-allowed";
        }
    }

    const countLetters = () => {
        let lettersLength = document.getElementById("lettersLength");
        let textArea = document.getElementById("Review-Content").value;
        lettersLength.textContent = textArea.length + "/156";
    }

    return (
        <div className="write-review">
            <h1>Write Review</h1>
            <p>
                <b>Note :</b> There are some elements we'de like you to talk about in your 
                review which are, Images & Photos Optimizations, Quality and Resolution
                of Images & Photos and The accesibilty to reach out with one of pictures taker (creator).
            </p>
            <form id="ReviewForm" onSubmit={submitReview} onKeyUp={check}>
                <h2>New Review</h2>
                <div className="user-info">
                    <div className="single-input">
                        <label>Full Name</label>
                        <input type="name" placeholder="John Doe" id="Full-Name" required autoComplete="off" />
                    </div>
                    <div className="single-input">
                        <label>Role</label>
                        <input type="name" placeholder="College Student, Designer, Developer..." id="Role" required autoComplete="off" />
                    </div>
                </div>
                <div className="single-input">
                    <label>Review content</label>
                    <textarea placeholder="Content..." id="Review-Content" maxLength="156" onChange={countLetters} required>
                    </textarea>
                    <span className="lettersLength" id="lettersLength">0/156</span>
                </div>
                <button title="Submit Review" id="submit-btn">
                    <span>Submit Review</span>
                    <img src="https://img.icons8.com/material-outlined/24/ffffff/send-letter.png" height="20px" width="20px" />
                </button>
            </form>
            <div className="submit-loading" id="submit-loading">
                <span className="submit-load"></span>
                <span>Submitting...</span>
            </div>
            <div className="review-sent" id="review-sent">
                <h2>Reveiw Submitted 🙌</h2>
                <p>
                    Your review has been successfully submitted, We'll be glad 
                    to add it to the site reviews after we process it, If it's 
                    valid you'll be able to see your review in the reviews list.
                </p>
                <h4>Thank you.</h4>
            </div>
        </div>
    )
}

export default WriteReview;